import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import splitLongWords from 'utils/splitLongWords';

const styles = () => ({
  root: {
    display: 'inline',
  },
});

const ReportsCreateEditFormField = ({
  input: { value },
  prefix,
  classes,
}) => (
  <Typography
    className={classes.root}
    variant="subheading"
  >
    {splitLongWords(`${prefix}${value.label}`)}
  </Typography>
);

ReportsCreateEditFormField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.string,
      }),
      PropTypes.string,
    ]),
  }).isRequired,
  prefix: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

ReportsCreateEditFormField.defaultProps = {
  prefix: '',
};

export default withStyles(styles)(ReportsCreateEditFormField);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditFormField.js